import { render, staticRenderFns } from "./widget-number.vue?vue&type=template&id=745579bf&scoped=true"
import script from "./widget-number.vue?vue&type=script&lang=js"
export * from "./widget-number.vue?vue&type=script&lang=js"
import style0 from "./widget-number.vue?vue&type=style&index=0&id=745579bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745579bf",
  null
  
)

export default component.exports